<template>
    <button :disabled="loading" @click.prevent="handleClick">
        <slot v-if="!loading"></slot>
        <template v-else>{{ __('Loading...') }}</template>
    </button>
</template>

<script>
export default {
  data () {
    return {
      loading: false
    }
  },

  props: {
    /**
     * This prop function must always return a promise.
     * If it doesn't, the loader will be set to false immediately.
     */
    onClick: {
      type: Function,
      required: true
    }
  },

  methods: {
    handleClick () {
      this.loading = true
      let promise = this.onClick()

      if (!(promise instanceof Promise)) {
        this.loading = false

        return
      }

      promise.finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
